import useMobileLayouts from 'mobile/hooks/useMobileLayouts';
import useMobileStyles from '../../hooks/useMobileStyles';

export const Background = ({ ...props }: { children?: JSX.Element }) => {
    const styles = useMobileStyles();
    const layouts = useMobileLayouts();
    return <div className={`${styles.background} ${layouts.screen}`}>{props.children}</div>;
};
